import React from 'react';
import { useTranslation } from 'react-i18next';

import './LoadingSpinner.css';

function LoadingSpinner(props) {
  const { t } = useTranslation();

  const getSpinnerClassName = () => {
    if (props.asOverlay) return 'loading-spinner__overlay';
    if (props.asImage) return 'image-cont';
    return 'center';
  };

  return (
    <div
      tabIndex={-1}
      role="status"
      aria-label={t('accessibility.loading')}
      className={`${getSpinnerClassName()}`}
    >
      <div className="lds-dual-ring" />
    </div>
  );
}

export default LoadingSpinner;
